import { useEffect, useState } from "react";
import { TaxSwitchEvent } from "../interfaces-base";

export function usePriceIsHT(): boolean {
  const [isHT, setIsHT] = useState<boolean>(false);

  useEffect(() => {
    const excludedTax = localStorage.getItem('excludedTax');
    if (excludedTax !== null) {
      setIsHT(JSON.parse(excludedTax));
    }

    const handleTaxSwitched = (e: CustomEvent<TaxSwitchEvent>): void => {
      setIsHT(e.detail.excludedTax);
    };
    document.body.addEventListener('onTaxSwitched', handleTaxSwitched);
    return () => document.body.removeEventListener('onTaxSwitched', handleTaxSwitched);
  }, []);

  return isHT;
}